"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useDerivedState(factory, deps) {
    var _a = react_1.useState(function () { return factory(); }), value = _a[0], setValue = _a[1];
    react_1.useEffect(function () {
        setValue(factory());
        // Allow passing deps from the consumer, linting should catch errors from consumer.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return [value, setValue];
}
exports.default = useDerivedState;
